import { render, staticRenderFns } from "./contatoAstec.vue?vue&type=template&id=b256d1e2"
import script from "./contatoAstec.vue?vue&type=script&lang=js"
export * from "./contatoAstec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports